import { render, staticRenderFns } from "./ReadOnlyDisplay.vue?vue&type=template&id=378bd1fe&scoped=true"
import script from "./ReadOnlyDisplay.vue?vue&type=script&lang=js"
export * from "./ReadOnlyDisplay.vue?vue&type=script&lang=js"
import style0 from "./ReadOnlyDisplay.vue?vue&type=style&index=0&id=378bd1fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378bd1fe",
  null
  
)

export default component.exports